import React from "react";

const DateFormatter = ({ dateString }) => {
      if (!dateString) {
    // Fallback if date is null, undefined, or empty
    return ;
  }
  const date = new Date(dateString);

  // Format parts (day, month, year separately)
  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "long" });
  const year = date.getFullYear();

  // Function to add suffix (st, nd, rd, th)
  const getDaySuffix = (d) => {
    if (d > 3 && d < 21) return "th"; // 4th-20th
    switch (d % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  };

  const formattedDate = `${day}${getDaySuffix(day)} ${month} ${year}`;

  return <p style={{display:"flex",alignItems:"center"}}>{formattedDate}</p>;
};

export default DateFormatter;
